/**
 * Chart kit entry (MASTER_PROMPT §6.3): mountChart(el, spec, opts).
 *
 * Every chart is plain 2D SVG (Rachit, 2026-10-21: only the login globe and the
 * World globe stay 3D; the 3D charts were removed for speed).
 * Returns { update(spec), inspect(i), dispose(), mode }.
 *
 *   const c = mountChart(el, { kind: "area", unit: "$", x, series: [{ role: "cash", label: "Cash", values }] });
 *   c.update(nextSpec);   // redraws with the new data
 */
import { mountSvgChart } from "./svg.js";

function mountChart(el, spec, opts = {}) {
  const impl = mountSvgChart(el, spec, opts);
  return {
    mode: "2d",
    get model() { return impl.model; },
    update(next) { impl.update(next); },
    inspect(i) { return impl.inspect(i); },
    dispose() { impl.dispose(); },
  };
}

export { mountChart };
